export default {
  "generic.cancel": "Cancel",
  "generic.confirm": "Confirm",
  "generic.delete": "Delete",
  "generic.api_unknown_error": "Unknown error occurred.",
  "generic.save": "Save",
  "generic.wait": "Please wait..",
  "generic.no": "No",
  "generic.yes": "Yes",
  "generic.empty": "A New Beginning!",
  "generic.reset": "Reset",
  "generic.status": "Status",
  "generic.details": "Details",
  "accounts.add": "Add Account",
  "accounts.not_found": "No Connections found",
  "accounts.connected": "Connected Accounts",
  "accounts.open_connected": "Open Connected Accounts",
  "accounts.manage": "Manage Connections",
  "accounts.search": "Search Connections",
  "accounts.toggle": "Toggle Connections",
  planner: "Planner",
  "planner.export_story.header": "Import project settings",
  "posts.timezone": "Timezone",
  "posts.filter": "Filters",
  "posts.filter.search": "Search (min. 3 chars)",
  "posts.filter.status": "Status",
  "posts.filter.status.all": "All",
  "posts.filter.status.failed": "Failed",
  "posts.filter.status.published": "Published",
  "posts.filter.status.to_publish": "Scheduled",
  "posts.filter.status.upcoming": "Upcoming",
  "posts.filter.status.past": "Past",
  "posts.delete": "Delete",
  "posts.edit": "Edit",
  "posts.open": "Open",
  "posts.multiply": "Multiply",
  "posts.multiply_post": "Multiply post",
  "posts.multiply.copies": "Number of copies",
  "posts.multiply.copies.tip": "Post will be copied that many times.",
  "posts.multiply.copies.error": "Number of copies must between 1 and 30.",
  "posts.multiply.span": "Days between each copy",
  "posts.multiply.span.tip": "Time span between each copy.",
  "posts.multiply.span.error": "Days span must be between 1 and 1000.",
  "posts.new": "New Post",
  "posts.posts": "Posts",
  "posts.repost": "Repost to...",
  "posts.use": "Use as post",
  "posts.schedule": "Schedule Post",
  "posts.scheduled": "Scheduled Post",
  "posts.search": "Search Posts",
  "posts.shareLink": "Share Link",
  "posts.publish_now": "Publish Now",
  "posts.published": "Published Post",
  "posts.failed": "Failed Post",
  "posts.no_posts": "No Posts Here. Yet!",
  "drafts.sidebar.header": "Drafts",
  "drafts.sidebar.search_placeholder": "Search Drafts...",
  "drafts.sidebar.no_items": "You haven't created any draft posts yet.",
  "drafts.add_draft": "Add draft",
  "simple_post.date_time.not_set": "Time not set",
  "calendar.view.day": "Day",
  "calendar.view.week": "Week",
  "calendar.view.month": "Month",
  "calendar.items.more": "Show {{count}} more",
  "calendar.items.less": "Show less",
  "calendar.menu.events_categories": "Events",
  "calendar.action.fullscreen.close": "Exit full screen",
  "calendar.action.fullscreen.open": "Open on full screen",
  "calendar.action.today": "Today",
  "calendar.action.select_date": "Select date",
  "calendar.action.prev_range": "Previous",
  "calendar.action.next_range": "Next",
  "calendar.action.go_to_day": "Open day",
  "calendar.action.add_post": "Schedule",
  "post_preview.select_to_preview": "Select post to preview",
  "post_preview.modal_title": "Post preview",
  "post_preview.not_available":
    "The post preview for this account is not available.",
  "post_preview.info": "Published post may look a bit different.",
  "post_preview.facebook.like": "Like",
  "post_preview.facebook.reply": "Reply",
  "post_preview.facebook.comment": "Comment",
  "post_preview.facebook.share": "Share",
  "post_preview.facebook.carousel.see_more_at": "See more at",
  "post_preview.linkedin.like": "Like",
  "post_preview.linkedin.comment": "Comment",
  "post_preview.linkedin.share": "Share",
  "post_preview.linkedin.send": "Send",
  "post_preview.linkedin.reply": "Reply",
  "post_preview.vkontakte.share": "Share",
  "post_preview.vkontakte.reply": "Reply",
  "post_preview.google.valid": "Valid",
  "post_preview.google.redeem_online": "Redeem online",
  "post_preview.google.show_code_at_store": "Show this code at the store",
  "social_types.1.full": "Facebook Profile",
  "social_types.1.main": "Facebook",
  "social_types.1.sub": "Profile",
  "social_types.2.full": "Facebook Page",
  "social_types.2.main": "Facebook",
  "social_types.2.sub": "Page",
  "social_types.3.full": "Facebook Group",
  "social_types.3.main": "Facebook",
  "social_types.3.sub": "Group",
  "social_types.5.full": "Twitter Profile",
  "social_types.5.main": "Twitter",
  "social_types.5.sub": "Profile",
  "social_types.8.full": "Google Profile",
  "social_types.8.main": "Google",
  "social_types.8.sub": "Profile",
  "social_types.9.full": "Google Page",
  "social_types.9.main": "Google",
  "social_types.9.sub": "Page",
  "social_types.10.full": "Google My Business",
  "social_types.10.main": "Google",
  "social_types.10.sub": "My Business",
  "social_types.11.full": "LinkedIn Profile",
  "social_types.11.main": "LinkedIn",
  "social_types.11.sub": "Profile",
  "social_types.12.full": "LinkedIn Group",
  "social_types.12.main": "LinkedIn",
  "social_types.12.sub": "Group",
  "social_types.13.full": "LinkedIn Company",
  "social_types.13.main": "LinkedIn",
  "social_types.13.sub": "Company",
  "social_types.21.full": "VKontakte Profile",
  "social_types.21.main": "VKontakte",
  "social_types.21.sub": "Profile",
  "social_types.22.full": "VKontakte Page",
  "social_types.22.main": "VKontakte",
  "social_types.22.sub": "Page",
  "social_types.23.full": "VKontakte Group",
  "social_types.23.main": "VKontakte",
  "social_types.23.sub": "Group",
  "social_types.24.full": "VKontakte Event",
  "social_types.24.main": "VKontakte",
  "social_types.24.sub": "Event",
  "social_types.30.full": "Instagram Personal",
  "social_types.30.main": "Instagram",
  "social_types.30.sub": "Personal",
  "social_types.31.full": "Instagram Business",
  "social_types.31.main": "Instagram",
  "social_types.31.sub": "Business",
  "social_types.35.full": "Pinterest Profile",
  "social_types.35.main": "Pinterest",
  "social_types.35.sub": "Profile",
  "social_types.36.full": "Pinterest Board",
  "social_types.36.main": "Pinterest",
  "social_types.36.sub": "Board",
  "accounts.enable_accounts": "Enable your account(s) to see the posts.",
  "accounts.enable_all": "Enable all accounts",
  "accounts.toggle_all_below": "Toggle all visible accounts",
  "accounts.selected": "Selected accounts",
  "accounts.selected.none": "--- none ---",
  "accounts.filter": "Filter accounts",
  "accounts.filter.search": "Search (min. 2 chars)",
  "accounts.filter.no_results": "No accounts that meet the criteria.",
  "accounts.indicator.expand.expand": "Expand accounts selector",
  "accounts.indicator.expand.collapse": "Collapse accounts selector",
  "post_editor_view.modal.create": "Schedule Post",
  "post_editor_view.modal.edit": "Edit Post",
  "post_editor_view.modal.custom-edit": "Edit Post",
  "post_editor_view.modal.draft-create": "Create Draft",
  "post_editor_view.modal.draft-edit": "Edit Draft",
  "post_editor.publish_now_confirm.title": "Publish now",
  "post_editor.publish_now_confirm.message":
    'You are about to publish your post NOW.<br>Please confirm, by clicking button "Publish now" below.',
  "post_editor.publish_now_confirm.confirm": "Publish now!",
  "post_editor.tab_state.error": "Error",
  "post_editor.tab_state.modified": "Modified",
  "post_editor.tabs.base": "Original",
  "post_editor.tabs.facebook": "Facebook",
  "post_editor.tabs.instagram": "Instagram",
  "post_editor.tabs.linkedin": "LinkedIn",
  "post_editor.tabs.twitter": "Twitter",
  "post_editor.tabs.vkontakte": "VK",
  "post_editor.tabs.pinterest": "Pinterest",
  "post_editor.tabs.google": "Google",
  "post_editor.errors.photo_required": "Photo is required.",
  "post_editor.errors.photo_video_required": "Photo or video is required.",
  "post_editor.errors.instagram_photo_ratio":
    "The photo aspect ratio for Instagram should be between {{ratio_from}} and {{ratio_to}}.",
  "post_editor.errors.instagram_video_support":
    "Video can only be added to the Instagram Business account.",
  "post_editor.errors.instagram_comment_support":
    "Comment can only be added to the Instagram Business account and will not be published to an Instagram Personal account.",
  "post_editor.errors.instagram_devices_required":
    "You must have the Postfity mobile application installed to publish (as reminders to mobile app) to your Instagram Personal account.",
  "post_editor.errors.instagram_mentions_limit":
    "Instagram allows to add up to {{max}} mentions of users.",
  "post_editor.errors.instagram_hashtags_limit":
    "Instagram allows to add up to {{max}} hashtags.",
  "post_editor.errors.linkedin_video_support":
    "Video can only be added to the LinkedIn Company account.",
  "post_editor.errors.twitter_single_account_support":
    "You can only publish to one Twitter account at the same time, so from selected Twitter accounts you are only posting to: {{name}} (@{{nickname}}).",
  "post_editor.errors.photo_limit_reached":
    "The photo limit has been reached. You can add up to {{max}} photo(s).",
  "post_editor.errors.video_limit_reached":
    "The video limit has been reached. You can add up to {{max}} video(s).",
  "post_editor.errors.no_accounts_selected":
    "Select the account where you want to publish the post.",
  "post_editor.errors.no_content": "Add something to the post.",
  "post_editor.errors.additional_google_post_title_required":
    "Title is required.",
  "post_editor.errors.additional_google_post_startDate_required":
    "Start date is required.",
  "post_editor.errors.additional_google_post_endDate_required":
    "End date is required.",
  "post_editor.errors.additional_google_post_redeemOnlineUrl_invalid":
    "Link to redeem offer is invalid. Required format: http://yourdomain.com or https://yourdomain.com.",
  "post_editor.errors.additional_google_post_callToActionUrl_required":
    "Button link is required.",
  "post_editor.errors.additional_google_post_callToActionUrl_invalid":
    "Button link is invalid. Required format: http://yourdomain.com or https://yourdomain.com.",
  "post_editor.errors.additional_pinterest_post_link_invalid":
    "Link is invalid. Required format: http://yourdomain.com or https://yourdomain.com.",
  "post_editor.errors.additional_facebook_carousel_items_required":
    "At least two carousel links are required.",
  "post_editor.errors.additional_facebook_carousel_items_invalid":
    "At least two carousel links are required.",
  "post_editor.errors.additional_facebook_carousel_endCardLink_required":
    "End card link is required.",
  "post_editor.errors.additional_facebook_carousel_endCardLink_invalid":
    "End card link is invalid. Required format: http://example.com or https://example.com.",
  "post_editor.infos.twitter_link_preview":
    "Twitter automatically shows a preview of the last link in the message and cannot be deleted.",
  "post_editor.check_errors":
    "This post cannot be scheduled. Please check highlighted areas.",
  "post_editor.message.placeholder": "Write some post here...",
  "post_editor.additional_fields.google.post.topicType": "Post type",
  "post_editor.additional_fields.google.post.topicType.STANDARD": "What's new",
  "post_editor.additional_fields.google.post.topicType.EVENT": "Event",
  "post_editor.additional_fields.google.post.topicType.OFFER": "Offer",
  "post_editor.additional_fields.google.post.title": "Title",
  "post_editor.additional_fields.google.post.startDate": "Start date",
  "post_editor.additional_fields.google.post.endDate": "End date",
  "post_editor.additional_fields.google.post.couponCode": "Coupon code",
  "post_editor.additional_fields.google.post.redeemOnlineUrl":
    "Link to redeem offer",
  "post_editor.additional_fields.google.post.termsConditions":
    "Terms and conditions",
  "post_editor.additional_fields.google.post.callToActionType": "Button",
  "post_editor.additional_fields.google.post.callToActionType.NONE": "None",
  "post_editor.additional_fields.google.post.callToActionType.BOOK": "Book",
  "post_editor.additional_fields.google.post.callToActionType.ORDER":
    "Order online",
  "post_editor.additional_fields.google.post.callToActionType.SHOP": "Buy",
  "post_editor.additional_fields.google.post.callToActionType.LEARN_MORE":
    "Learn more",
  "post_editor.additional_fields.google.post.callToActionType.SIGN_UP":
    "Sign up",
  "post_editor.additional_fields.google.post.callToActionUrl": "Link",
  "post_editor.additional_fields.pinterest.post.title": "Title",
  "post_editor.additional_fields.pinterest.post.imageAlt": "Alt text",
  "post_editor.additional_fields.pinterest.post.link": "Link",
  "post_editor.date_time.not_set": "Time not set",
  "post_editor.date_time.time": "Time",
  "post_editor.date_time.timezone": "Timezone",
  "post_editor.date_time.clear_time": "Clear time",
  "post_editor.date_time.reset_time": "Reset time",
  "post_editor.date_time.use_customized_times": "Custom time for each account",
  "post_editor.date_time.cancel_customized_times": "Same time for all accounts",
  "post_editor.date_time.add_delay_time": "Add a delay between posts",
  "post_editor.date_time.delay.minutes": "minutes",
  "post_editor.date_time.delay.hours": "hours",
  "post_editor.date_time.delay.days": "days",
  "post_editor.toolbar.settings": "Settings",
  "post_editor.toolbar.post_preview": "Preview post",
  "post_editor.toolbar.add_image": "Add image (or drag file to editor)",
  "post_editor.toolbar.add_video": "Add video (or drag file to editor)",
  "post_editor.toolbar.create_carousel": "Create carousel",
  "post_editor.toolbar.create_image": "Create image",
  "post_editor.toolbar.create_snapshot": "Generate snapshot",
  "post_editor.toolbar.comments": "Comments",
  "post_editor.toolbar.snippets": "Snippets",
  "post_editor.toolbar.emoji": "Emoji",
  "post_editor.toolbar.media_library": "Media library",
  "post_editor.toolbar.ai_assistant": "AI Assistant",
  "post_editor.settings.shortlinks_enabled": "Shortlinks enabled",
  "post_editor.settings.utm_enabled": "UTM codes enabled",
  "post_editor.shortlink.enable_shortening": "Enable shortening for this link",
  "post_editor.shortlink.disable_shortening":
    "Disable shortening for this link",
  "post_editor.reset_post_state.title": "Reset this customization to original",
  "post_editor.reset_post_state.confirm_modal.title":
    "Reset this customization",
  "post_editor.reset_post_state.confirm_modal.message":
    "Reset this customization to original. This action cannot be undone.",
  "post_editor.reset_post_state.confirm_modal.confirm": "Reset",
  "post_editor.reset_all_posts_state.title":
    "Reset all customizations to original",
  "post_editor.reset_all_posts_state.confirm_modal.title":
    "Reset all customizations",
  "post_editor.reset_all_posts_state.confirm_modal.message":
    "Reset all customizations to original. This action cannot be undone.",
  "post_editor.reset_all_posts_state.confirm_modal.confirm": "Reset",
  "post_editor.actions.save": "Save post",
  "post_editor.actions.add_schedule": "Schedule",
  "post_editor.actions.add_buffer": "Add to queue",
  "post_editor.actions.publish_now": "Publish now",
  "post_editor.actions.post_add_draft": "Add draft",
  "post_editor.actions.save_draft": "Save draft",
  "post_editor.actions.add_draft": "Add draft",
  "post_editor.actions.add_for_approval_draft": "Add for approval",
  "post_editor.schedule_time.title": "Select publication time",
  "post_editor.schedule_time.confirm": "Schedule!",
  "post_editor.media.errors.wrong_file_data": "Wrong file data.",
  "post_editor.media.errors.file_already_added": "The file is already added.",
  "post_editor.media.errors.unsupported_file_type": "Unsupported file type.",
  "post_editor.media.file_added": "File added to post.",
  "date_time_picker.time": "Time",
  "date_time_picker.clear": "Clear",
  "post_link_preview.image.upload": "Upload your own image",
  "post_link_preview.image.select": "Select a different image",
  "post_link_preview.title.placeholder": "Write some link title here...",
  "post_link_preview.title.click_to_change": "Click to change the link title",
  "post_link_preview.description.placeholder":
    "Write some link description here...",
  "post_link_preview.description.click_to_change":
    "Click to change the link description",
  "post_link_preview.link.click_to_change": "Click to change the link",
  "post_link_preview.link.url": "URL",
  "post_link_preview.link.url_placeholder": "https://example.com",
  "post_link_preview.validation.url_required": "The URL is required.",
  "post_link_preview.validation.url_incorrect":
    "The URL is incorrect. Required format: http://example.com or https://example.com.",
  "post_link_preview.remove": "Remove link",
  "post_link_preview.image_selector.modal_title": "Select link image",
  "post_link_preview.image_selector.select": "Select",
  "post_carousel.end_card.title": "Display end card of carousel link",
  "post_carousel.end_card_link.title": "End card link",
  "post_carousel.action.delete": "Delete carousel",
  "post_carousel.action.delete_confirmation_title": "Delete carousel",
  "post_carousel.action.delete_confirmation":
    "Are you sure you want to delete carousel?",
  "post_carousel.action.add_next": "Add next link",
  "post_media_preview.modal.title": "Preview",
  "post_media_list.clipboard.title": "Media clipboard",
  "post_media_list.actions.add_to_post": "Add to post",
  "post_media_list.actions.remove_from_post": "Remove from post",
  "post_media_list.actions.remove_from_list": "Remove from list",
  "post_media_list.actions.open_in_image_editor": "Open in an image editor",
  "post_media_list.actions.show_preview": "Open preview",
  "post_file_picker.info":
    "You can select up to {{number_of_files}} file(s) with extensions: {{allowed_file_types}} and max {{file_size}} file size.",
  "post_file_picker.sources.my_photos": "My Photos",
  "post_file_picker.sources.my_videos": "My Videos",
  "emoji.search": "Search",
  "emoji.clear": "Clear",
  "emoji.not_found": "No Emoji Found",
  "emoji.skin_text": "Choose your default skin tone",
  "emoji.categories_label": "Emoji categories",
  "emoji.category.search": "Search Results",
  "emoji.category.recent": "Frequently Used",
  "emoji.category.smileys": "Smileys & Emotion",
  "emoji.category.people": "People & Body",
  "emoji.category.nature": "Animals & Nature",
  "emoji.category.foods": "Food & Drink",
  "emoji.category.activity": "Activity",
  "emoji.category.places": "Travel & Places",
  "emoji.category.objects": "Objects",
  "emoji.category.symbols": "Symbols",
  "emoji.category.flags": "Flags",
  "emoji.category.custom": "Custom",
  "emoji.skin_tone.1": "Default Skin Tone",
  "emoji.skin_tone.2": "Light Skin Tone",
  "emoji.skin_tone.3": "Medium-Light Skin Tone",
  "emoji.skin_tone.4": "Medium Skin Tone",
  "emoji.skin_tone.5": "Medium-Dark Skin Tone",
  "emoji.skin_tone.6": "Dark Skin Tone",
  "snippets.add": "Add new snippet",
  "snippets.content": "Content",
  "snippets.edit": "Edit snippets",
  "snippets.edit_close": "Close edit mode",
  "snippets.enter_snippet": "Enter your snippet here..",
  "snippets.enter_snippet_error":
    "Please enter your snippet's content before saving it.",
  "snippets.title": "Title",
  "snippets.title_tip":
    "Optional - if provided, title will be shown on the snippets list instead of content.",
  "snippets.search": "Search",
  "snippets.no_snippets":
    "You don't have any snippets added yet. Go ahead, click on the button below and create some snippets to speed up your work on future posts!",
  "account.settings.utm_enabled": "UTM codes enabled",
  "account.settings.utm_source": "UTM Source",
  "account.settings.utm_medium": "UTM Medium",
  "account.settings.utm_campaign": "UTM Campaign",
  "account.settings.shortlinks_enabled": "Shortlinks enabled",
  "calendar.navbar.action.schedule_post": "Schedule Post",
  "calendar.navbar.action.open_draft": "Open Draft",
  "calendar.navbar.action.import_from_file": "Bulk Schedule Posts",
  "calendar.empty_screen.title": "Welcome to Simplified calendar",
  "calendar.empty_screen.description":
    "Now create, collaborate and publish all from one app.",
  "calendar.empty_screen.action": "Let's get started",
};
